"use client";

import { Badge, Button, Link } from "@spheron/ui-library";
import SpheronIcon from "@spheron/ui-library/dist/assets/spheron-specific/spheron-logo.svg";
import Arrow from "@spheron/ui-library/dist/assets/arrow-right-1.svg";
import { SPHERON_APP_URL, SPHERON_SUPPORT_EMAIL } from "@/config";

const PhaseOut = () => {
  return (
    <div className="min-h-[calc(100vh-160px)] w-full flex items-center justify-center py-16">
      <div
        className="w-full max-w-[640px] flex flex-col items-center text-center
        gap-y-6 rounded-lg border px-6 py-12 lg:px-12 lg:py-14"
        style={{ borderColor: "var(--base-fg-color)" }}
      >
        <div
          className="flex items-center justify-center w-16 h-16 rounded-full"
          style={{ backgroundColor: "var(--cards-rows-etc-hover)" }}
        >
          <SpheronIcon className="w-9 h-9 text-logo-primary dark:text-dark-logo-primary" />
        </div>

        <Badge
          badgeType="default"
          solid={false}
          size="large"
          isBold
          text="Provider Node · Deprecated"
        />

        <div className="flex flex-col gap-y-3">
          <h1
            className="text-2xl lg:text-[28px] font-700 leading-tight
            text-base-heading-text-color dark:text-dark-base-heading-text-color"
          >
            We&apos;re phasing out Provider Node
          </h1>
          <p
            className="text-sm lg:text-base font-400 leading-6
            text-base-para-text-color dark:text-dark-base-para-text-color"
          >
            Spheron Provider Node is no longer being maintained, and this
            dashboard has been retired. Thank you to everyone who ran a node and
            helped build the network. It wouldn&apos;t have been possible
            without you.
          </p>
        </div>

        <div
          className="w-full border-t"
          style={{ borderColor: "var(--base-fg-color)" }}
        />

        <div className="flex flex-col items-center gap-y-4 w-full">
          <p
            className="text-sm font-400 leading-6
            text-base-sub-text-color dark:text-dark-base-sub-text-color"
          >
            Looking to rent GPUs? Everything you need has moved to our new
            platform.
          </p>
          <Button
            classname="max-h-[44px] min-w-[220px]"
            buttonType="primary"
            size="medium"
            label="Rent GPUs on app.spheron.ai"
            fillWidth={false}
            leftIcon={<Arrow className="w-5 h-5" />}
            onClick={() => window.open(SPHERON_APP_URL, "_blank")}
          />
        </div>

        <div
          className="flex flex-row flex-wrap items-center justify-center gap-x-1
          text-sm font-400 text-base-sub-text-color dark:text-dark-base-sub-text-color"
        >
          <span>Have questions? Reach out to</span>
          <Link
            size="default"
            isBold
            type="secondary"
            classname="dark:!text-dark-base-link !text-base-link"
            text={SPHERON_SUPPORT_EMAIL}
            onClick={() =>
              window.open(`mailto:${SPHERON_SUPPORT_EMAIL}`, "_self")
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PhaseOut;
